import { render, staticRenderFns } from "./SimpleBreadcrumbRouter.vue?vue&type=template&id=617aa745&"
import script from "./SimpleBreadcrumbRouter.vue?vue&type=script&lang=js&"
export * from "./SimpleBreadcrumbRouter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports